module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Weather/Moon-fca40b1ff57290b785c5291873e940b99c522247a383ffbea35041c4c978bd92.svg";